import React from "react";
import { PatientMissingDocsEditTemplate } from "themes/application/patient-missing-docs/components";
import { observer } from "mobx-react";

@observer
class PatientMissingDocsEdit extends React.Component {
	render() {
		return <PatientMissingDocsEditTemplate {...this.props} />;
	}
}

export default PatientMissingDocsEdit;